import React from 'react'

import { useTranslation } from 'react-i18next'

import { Box, Button, Text } from '@enechain/ecloud-designsystem'

type Props = {
  period: 30 | 90
  onChange: (p: 30 | 90) => void
}

export const MarginReportPeriodSelector: React.FC<Props> = ({
  period,
  onChange,
}) => {
  const { t } = useTranslation(['component'])

  return (
    <Box
      backgroundColor="Surface.quaternary"
      borderRadius="6px"
      padding="1"
      display="flex"
      gap="1"
      alignItems="center"
    >
      <Button
        backgroundColor={period === 30 ? 'Surface.primary' : 'transparent'}
        border="none"
        borderRadius="4px"
        paddingY="1"
        paddingX="3"
        height="32px"
        style={{ cursor: 'pointer' }}
        onClick={() => onChange(30)}
      >
        <Text
          fontSize="md"
          fontWeight="600"
          color={period === 30 ? 'Text.highEmphasis' : 'Text.midEmphasis'}
        >
          {t('component:features.margin_report.period_selector.one_month')}
        </Text>
      </Button>
      <Button
        backgroundColor={period === 90 ? 'Surface.primary' : 'transparent'}
        border="none"
        borderRadius="4px"
        paddingY="1"
        paddingX="3"
        height="32px"
        style={{ cursor: 'pointer' }}
        onClick={() => onChange(90)}
      >
        <Text
          fontSize="md"
          fontWeight="600"
          color={period === 90 ? 'Text.highEmphasis' : 'Text.midEmphasis'}
        >
          {t('component:features.margin_report.period_selector.three_months')}
        </Text>
      </Button>
    </Box>
  )
}
